import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '@cloudscape-design/components/badge';
import type { HealthSignalKind } from '@etiquetachef/types';
import { SIGNAL_BADGE_COLOR } from './signalColor';

/** Badge colorido de um sinal de saúde (cor de `signalColor.ts`). */
export function HealthBadge({ kind }: { kind: HealthSignalKind }): React.JSX.Element {
  const { t } = useTranslation();
  return <Badge color={SIGNAL_BADGE_COLOR[kind]}>{t(`health.signal.${kind}`)}</Badge>;
}
